/**
 * Formats an ISO date string (YYYY-MM-DD) without timezone conversion
 * Returns format: "Weekday, Mon DD, YYYY" (e.g., "Monday, Jan 15, 2026")
 */
export const formatDateTzNaive = (isoDate: string): string => {
  // Parse the date string directly without timezone conversion
  const [year, month, day] = isoDate.split('T')[0].split('-').map(Number);
  const date = new Date(year, month - 1, day);

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const dayName = days[date.getDay()];
  const monthName = months[date.getMonth()];
  const dayNum = date.getDate();
  const yearNum = date.getFullYear();

  return `${dayName}, ${monthName} ${dayNum}, ${yearNum}`;
};

/**
 * Formats a Firestore Timestamp or Date as a time-only string without timezone conversion.
 * Returns format: "h:mm AM/PM" (e.g., "3:30 PM")
 */
export const formatTimeTzNaive = (value: any): string => {
  if (!value) return '';
  const d: Date = value.toDate ? value.toDate() : new Date(value);
  if (isNaN(d.getTime())) return '';
  let hours = d.getHours();
  const minutes = d.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${hours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
};

/**
 * Formats a Firestore Timestamp or Date as a date string without timezone conversion.
 * Returns format: "Mon DD, YYYY" (e.g., "Jan 15, 2026")
 */
export const formatDateValueTzNaive = (value: any): string => {
  if (!value) return '';
  const d: Date = value.toDate ? value.toDate() : new Date(value);
  if (isNaN(d.getTime())) return '';
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};
